export default __webpack_public_path__ + "static/media/rocket.6c53707c.svg";